import ProductColorVariants from "./product-color-variants";
import { getPopup } from "./common";
import { PopupOptions } from "./popup";


export default class ColorVariantPopupLink {
    private baseElement: HTMLElement;
    private loadProductPageFunction: (string) => Promise<void>;

    constructor(element: HTMLElement, loadProductPageFunction: (string) => Promise<void>) {
        this.baseElement = element;
        this.loadProductPageFunction = loadProductPageFunction;
    }

    public init(): void {
        this.baseElement.addEventListener('click', (e) => this.openPopup(e));
    }

    private openPopup(e: Event): any {
        e.preventDefault();
        const popup = new ProductColorVariants(getPopup(<PopupOptions>{ id: 'all-color-variants-popup' }));
        popup.show(true, (productUrl) => this.loadProductPageFunction(productUrl));
    }
}
